export class RegularExpressions {
  //  static mobileStringType = /^(0|\+98|0098|98)?([ ]|-|[()]){0,2}9[0|1|2|3|4|9]([ ]|-|[()]){0,2}(?:[0-9]([ ]|-|[()]){0,2}){8}$/gm;
  //  static mobilePrefix98Type = /^(0|\+98|0098|98)?([ ]|-|[()]){0,2}9[0|1|2|3|4|9]([ ]|-|[()]){0,2}(?:[0-9]([ ]|-|[()]){0,2}){8}$/m;
  static mobileNumberPrefixTo98 = /^(\+989|00989|989|09)\d{9}$/m;
  static mobileNumberPrefixTo98EnglishAndPersian = /^(?:[\++]?[۹۹|98|۹۸|00۹۸|۰۰۹۸|۰۹|09]{2,4})[0-9۰-۹]{9}$/m;
  static mobileNumberPrefixTo98Global =
    /^(9|09|989|\+989|00989)(?<num>\d{9}$)/gm;
  static globalMobileNumbersGlobal =
    /^(?!.*(09|9|989|00989|\+989)(99|[3](2|1|4))[0-9](\d{6})$)(?!.*((09|9|989|00989|\+989)((99(20|21|22)\d{5})|(20|21|22|23)[0-9]\d{6}))$)(?!.*(09|9|989|00989|\+989)(00|01|02|03|04|05|30|33|35|36|37|38|39)[0-9]\d{6}$)(?!.*(09|9|989|00989|\+989)(?!99)([1|9][0-9])(\d{7})$)^\+?[1-9]\d{1,14}$/gm;
  static globalMobileNumbers =
    /^(?!.*(09|9|989|00989|\+989)(99|[3](2|1|4))[0-9](\d{6})$)(?!.*((09|9|989|00989|\+989)((99(20|21|22)\d{5})|(20|21|22|23)[0-9]\d{6}))$)(?!.*(09|9|989|00989|\+989)(00|01|02|03|04|05|30|33|35|36|37|38|39)[0-9]\d{6}$)(?!.*(09|9|989|00989|\+989)(?!99)([1|9][0-9])(\d{7})$)^\+?[1-9]\d{1,14}$/m;
  static globalMobileNumbersForContactsGlobal = /^\+?[0-9]\d{1,14}$/gm;
  static globalMobileNumbersForContact = /^\+?[0-9]\d{1,14}$/m;
  static onlyNumbers = /[^0-9\n-]*/g;
  static onlyNumbersAndComma = /[^0-9,\n-]*/g;
  static justIntegerNumbers = /^\d+$/;
  static justDecimalNumbers = /^-?\d*\.\d+$/;
  static thousandSeparator = /\B(?=(\d{3})+(?!\d))/g;

  static emptyLine = /^\s*\n/gm;
  static newLine = /\r?\n/;

  static mobilesGroup = /^(9|09|989|\+989|00989)(?<num>\d{9}$)/gm;
  static removeEmptyLine = /^\s*\n/gm;
  static justNumber: string = '[- +()0-9]+';

  static rangeNumber = /\b[1-9][0-9]{3,11}\*$|\b[1-9][0-9]{3,12}\?{1,10}$/m;
  // static singleRangeNumber=/\b[1-9][0-9]{3,12}\?{1,10}$/g;
  // @"\b[1-9][0-9]{3,12}?{1,10}$"

  static domain =
    /^((https?|http|HTTPS|HTTP):\/\/)+(www.|WWW.)?[a-z0-9|A-Z0-9]+(\.[a-z|A-Z]{2,}){1,3}(#?\/?[a-zA-Z0-9#]+)*?(\?[a-zA-Z0-9-_]+=[a-zA-Z0-9-%]+&?)?$/;

  // static identityDomain=/^(?=.{1,255}$)(?!-)[A-Za-z0-9\-]{1,63}(\.[A-Za-z0-9\-]{1,63})*\.?(?<!-)$/;
  // static url=/https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/;

  static url =
    /[(http(s)?):\/\/(www\.)?a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/i;

  static identityDomain =
    /^(((?:https?:\/\/)|(?:HTTPS?:\/\/))?[^./]+(?:\.[^./]+)+(?:\/.*)?)$/;

  // static ip=/((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)/;
  static ip = /^((25[0-5]|(2[0-4]|1\d|[1-9]|)\d)(\.(?!$)|$)){4}$/;

  static justEnglishAndNumericCharacters = /^[A-Za-z][A-Za-z0-9]*$/;

  static englishCharacters = /^[A-Za-z۰۱۲۳۴۵۶۷۸۹0-9]*$/;

  static floatNumbers = /^\d{1,3}(?:\.\d{1,2})?$/;

  //  static password=/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$@$!%*?&])[A-Za-z\d$@$!%*?&].{8,}$/;
  static password =
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{8,20}$/;
  static symbols = /[-!$%^&*()_+|~=`{}\[\]:";'<>?\/]/g;

  static securePassword =
    /^(?=(.*[a-z]){1,})(?=(.*[A-Z]){1,})(?=(.*[0-9]){1,})(?=(.*[!@#$%^&*()\-__+.]){1,}).{8,}$/;
  static smsBodyForbiddenCharacters = /^[^\\]*$/;

  static urlPageSize = /PageSize=[0-9]+/;
  static urlPageNumber = /PageNumber=[0-9]+/;
  static urlChildKey = /key-[a-z,A-Z,0-9]+=[^&]+/;

  static urlDefaultFilters(filter) {
    return `${filter.field}_${filter.operator}_[^&]+=[^&]*${encodeURIComponent(
      filter.value.substring(0, 19)
    )}[^&]*(&|$)`;
  }
}
